var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18 .007h-7.087c-.53 0-1.04.21-1.414.586L.592 9.5a2 2 0 0 0 0 2.827l7.086 7.086a2 2 0 0 0 2.827 0l8.906-8.906c.376-.374.587-.883.587-1.413V2.007a2 2 0 0 0-2-2H18zM15.007 7a2 2 0 1 1-.09-3.999A2 2 0 0 1 15.007 7z", fill: "#23282D" })
  );
});